import { Union, Record } from "../fable_modules/fable-library.3.7.1/Types.js";
import { union_type, class_type, record_type, int32_type, string_type } from "../fable_modules/fable-library.3.7.1/Reflection.js";
import { columnDef_header_Z5FD1F5D2, columnDef_id_Z721C83C5, columnDef_cell_Z1DDB00E5, columnDef_accessorKey_Z721C83C5, columnDef_columns_Z2906D979, columnDef_footer_Z5FD1F5D2, columnDef_header_Z721C83C5 } from "../../Feliz.TanStack.Table/ColumnDef.fs.js";
import { singleton as singleton_1, ofArray } from "../fable_modules/fable-library.3.7.1/List.js";
import { createElement } from "react";
import { Table_getFooterGroups_Z4395D14A, Table_getRowModel_Z4395D14A, Table_getVisibleCells_773C3262, Table_getContext_Z78EF7AD2, Table_getHeaderGroups_Z4395D14A, Table_getContext_315F98D7, Html_flexRender_Z6DEE00B4, Table_init_Z5C3B000E } from "../../Feliz.TanStack.Table/Table.fs.js";
import { tableProps_columns_Z2906D979 } from "../../Feliz.TanStack.Table/TableProps.fs.js";
import { Cmd_none } from "../fable_modules/Fable.Elmish.4.0.0-beta-3/cmd.fs.js";
import { singleton, map, delay, toList } from "../fable_modules/fable-library.3.7.1/Seq.js";
import { createObj } from "../fable_modules/fable-library.3.7.1/Util.js";
import { Interop_reactApi } from "../fable_modules/Feliz.1.67.0/Interop.fs.js";
import { join } from "../fable_modules/fable-library.3.7.1/String.js";
import { useFeliz_React__React_useElmish_Static_B42E862 } from "../fable_modules/Feliz.UseElmish.1.6.0/UseElmish.fs.js";

export class Person extends Record {
    constructor(Firstname, Lastname, Age, Visits, Status, Progress) {
        super();
        this.Firstname = Firstname;
        this.Lastname = Lastname;
        this.Age = (Age | 0);
        this.Visits = (Visits | 0);
        this.Status = Status;
        this.Progress = (Progress | 0);
    }
}

export function Person$reflection() {
    return record_type("Examples.Groups.Person", [], Person, () => [["Firstname", string_type], ["Lastname", string_type], ["Age", int32_type], ["Visits", int32_type], ["Status", string_type], ["Progress", int32_type]]);
}

export const defaultData = [new Person("Ruthie", "Hirthe", 2, 217, "single", 96), new Person("Domenico", "Swift", 7, 497, "relationship", 70), new Person("Omer", "Zboncak", 13, 667, "complicated", 12), new Person("Esmeralda", "Kihn", 9, 262, "complicated", 6), new Person("Amara", "Bergnaum", 31, 386, "single", 94), new Person("Meredith", "Weber", 32, 509, "complicated", 76), new Person("Kareem", "Bashirian", 33, 802, "relationship", 83), new Person("Rosalyn", "Hoppe", 6, 464, "single", 57), new Person("Marcella", "Powlowski", 21, 758, "single", 10), new Person("Jesus", "Rowe", 39, 738, "complicated", 44), new Person("Astrid", "Pfeffer", 9, 644, "complicated", 76), new Person("Trey", "Keebler", 0, 487, "single", 5), new Person("Verdie", "Mraz", 25, 610, "complicated", 83), new Person("Paige", "Torphy", 22, 63, "single", 26), new Person("Cassandre", "Koepp", 6, 827, "relationship", 11), new Person("Walker", "Farrell", 34, 836, "complicated", 63), new Person("Brenna", "Koss", 25, 150, "complicated", 44), new Person("Carlos", "Buckridge", 10, 766, "complicated", 20), new Person("Francesca", "Tremblay", 9, 245, "relationship", 20), new Person("Nat", "Ryan", 24, 561, "single", 32)];

export const defaultColumns = ofArray([ofArray([columnDef_header_Z721C83C5("Name"), columnDef_footer_Z5FD1F5D2((props) => props.column.id), columnDef_columns_Z2906D979(ofArray([ofArray([columnDef_accessorKey_Z721C83C5("Firstname"), columnDef_cell_Z1DDB00E5((info) => info.getValue()), columnDef_footer_Z5FD1F5D2((props_1) => props_1.column.id)]), ofArray([columnDef_accessorKey_Z721C83C5("Lastname"), columnDef_id_Z721C83C5("Lastname"), columnDef_cell_Z1DDB00E5((info_1) => info_1.getValue()), columnDef_header_Z5FD1F5D2((_arg1) => createElement("span", {
    children: "Last Name",
})), columnDef_footer_Z5FD1F5D2((props_3) => props_3.column.id)])]))]), ofArray([columnDef_header_Z721C83C5("info"), columnDef_footer_Z5FD1F5D2((props_4) => props_4.column.id), columnDef_columns_Z2906D979(ofArray([ofArray([columnDef_accessorKey_Z721C83C5("Age"), columnDef_header_Z5FD1F5D2((_arg2) => "Age"), columnDef_footer_Z5FD1F5D2((props_5) => props_5.column.id)]), ofArray([columnDef_header_Z721C83C5("More Info"), columnDef_columns_Z2906D979(ofArray([ofArray([columnDef_accessorKey_Z721C83C5("Visits"), columnDef_header_Z5FD1F5D2((_arg3) => createElement("span", {
    children: "Visits",
})), columnDef_footer_Z5FD1F5D2((props_7) => props_7.column.id)]), ofArray([columnDef_accessorKey_Z721C83C5("Status"), columnDef_header_Z721C83C5("Status"), columnDef_footer_Z5FD1F5D2((props_8) => props_8.column.id)]), ofArray([columnDef_accessorKey_Z721C83C5("Progress"), columnDef_header_Z721C83C5("Profile Progress"), columnDef_footer_Z5FD1F5D2((props_9) => props_9.column.id)])]))])]))])]);

export class State extends Record {
    constructor(Table) {
        super();
        this.Table = Table;
    }
}

export function State$reflection() {
    return record_type("Examples.Groups.State", [], State, () => [["Table", class_type("Feliz.TanStack.Table.Types.Table`1", [Person$reflection()])]]);
}

export class Msg extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Nop"];
    }
}

export function Msg$reflection() {
    return union_type("Examples.Groups.Msg", [], Msg, () => [[]]);
}

export function init() {
    return [new State(Table_init_Z5C3B000E(ofArray([["data", defaultData], tableProps_columns_Z2906D979(defaultColumns)]))), Cmd_none()];
}

export function update(msg, state) {
    return [state, Cmd_none()];
}

export function view(state, dispatch) {
    let elems_6;
    let thead;
    const children = toList(delay(() => map((headerGroup) => {
        let elems_1;
        return createElement("tr", createObj(ofArray([["key", headerGroup.id], (elems_1 = toList(delay(() => map((header) => {
            let elems;
            return createElement("th", createObj(ofArray([["key", header.id], ["colSpan", header.colSpan], (elems = toList(delay(() => (header.isPlaceholder ? singleton(null) : singleton(Html_flexRender_Z6DEE00B4(header.column.columnDef.header, Table_getContext_315F98D7(header)))))), ["children", Interop_reactApi.Children.toArray(Array.from(elems))])])));
        }, headerGroup.headers))), ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))])])));
    }, Table_getHeaderGroups_Z4395D14A(state.Table))));
    thead = createElement("thead", {
        children: Interop_reactApi.Children.toArray(Array.from(children)),
    });
    let tbody;
    const children_4 = toList(delay(() => map((row) => {
        let elems_2;
        return createElement("tr", createObj(ofArray([["key", row.id], (elems_2 = toList(delay(() => map((cell) => {
            const children_2 = singleton_1(Html_flexRender_Z6DEE00B4(cell.column.columnDef.cell, Table_getContext_Z78EF7AD2(cell)));
            return createElement("td", {
                children: Interop_reactApi.Children.toArray(Array.from(children_2)),
            });
        }, Table_getVisibleCells_773C3262(row)))), ["children", Interop_reactApi.Children.toArray(Array.from(elems_2))])])));
    }, Table_getRowModel_Z4395D14A(state.Table).rows)));
    tbody = createElement("tbody", {
        children: Interop_reactApi.Children.toArray(Array.from(children_4)),
    });
    let tfoot;
    const children_6 = toList(delay(() => map((footerGroup) => {
        let elems_4;
        return createElement("tr", createObj(ofArray([["key", footerGroup.id], (elems_4 = toList(delay(() => map((footer) => {
            let elems_3;
            return createElement("th", createObj(ofArray([["key", footer.id], ["colSpan", footer.colSpan], (elems_3 = toList(delay(() => (footer.isPlaceholder ? singleton(null) : singleton(Html_flexRender_Z6DEE00B4(footer.column.columnDef.header, Table_getContext_315F98D7(footer)))))), ["children", Interop_reactApi.Children.toArray(Array.from(elems_3))])])));
        }, footerGroup.headers))), ["children", Interop_reactApi.Children.toArray(Array.from(elems_4))])])));
    }, Table_getFooterGroups_Z4395D14A(state.Table))));
    tfoot = createElement("tfoot", {
        children: Interop_reactApi.Children.toArray(Array.from(children_6)),
    });
    return createElement("div", createObj(ofArray([["className", join(" ", ["p-2"])], (elems_6 = [createElement("table", {
        children: Interop_reactApi.Children.toArray([thead, tbody, tfoot]),
    })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_6))])])));
}

export function Component() {
    const patternInput = useFeliz_React__React_useElmish_Static_B42E862(init, update);
    return view(patternInput[0], patternInput[1]);
}

//# sourceMappingURL=Groups.fs.js.map
